import React from 'react';
import { View } from 'react-native';
import Toast from 'src/components/Toast/Toast';
import { styles } from '../screens/CompanyLandingScreen/CompanyLandingScreen.styles';

interface ErrorToastProps {
  saveCompanyErrorToast: boolean;
}

const ErrorToast: React.FC<ErrorToastProps> = ({ saveCompanyErrorToast }) => {
  if (!saveCompanyErrorToast) return null;

  return (
    <View style={styles.toastContainer}>
      <Toast
        type="error"
        text="An error occurred while saving company details. Please try again later."
        animate={true}
      />
    </View>
  );
};

export default ErrorToast;
